import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import AuthLayout from '../../components/layout/AuthLayout';
import { notify, getErrorMessage } from '../../components/feedback/notify';

function EsqueceuSenha() {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [showPassword, setShowPassword] = useState(false);
    const [senha, setSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!token) {
            navigate("../");
        }
    }, [token, navigate]);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleSubmit = async (event) => {
        event?.preventDefault();
        if (!senha || !confirmarSenha) {
            notify.warning("Por favor, preencha todos os campos.");
            return;
        }
        if (senha.length < 6) {
            notify.warning("A senha deve ter pelo menos 6 caracteres.");
            return;
        }
        if (senha !== confirmarSenha) {
            notify.warning("As senhas não coincidem.");
            return;
        }
        try {
            setLoading(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/redefinirSenhaAdmin`, { token, senha });

            if (data?.status && data.status !== 200) {
                notify.error(data.message || "Não foi possível redefinir a senha. O link pode ter expirado.");
                return;
            }

            notify.success("Senha alterada com sucesso. Faça login com a nova senha.");
            setTimeout(() => navigate("../"), 1000);
        } catch (err) {
            console.error(err);
            notify.error(getErrorMessage(err, "Não foi possível redefinir a senha. Tente novamente."));
        } finally {
            setLoading(false);
        }
    };

    const passwordAdornment = {
        input: {
            endAdornment: (
                <InputAdornment position="end">
                    <IconButton
                        aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        size="small"
                    >
                        {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                    </IconButton>
                </InputAdornment>
            ),
        },
    };

    return (
        <AuthLayout
            title="Redefinir senha"
            subtitle="Crie uma nova senha com pelo menos 6 caracteres."
            footer={
                <Link component="button" type="button" variant="body2" underline="hover" color="text.secondary" onClick={() => navigate("../")}>
                    Voltar para o login
                </Link>
            }
        >
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <TextField
                    label="Nova senha"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    size="small"
                    fullWidth
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    slotProps={passwordAdornment}
                />
                <TextField
                    label="Confirmar nova senha"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    size="small"
                    fullWidth
                    value={confirmarSenha}
                    onChange={(e) => setConfirmarSenha(e.target.value)}
                    error={Boolean(confirmarSenha) && senha !== confirmarSenha}
                    helperText={Boolean(confirmarSenha) && senha !== confirmarSenha ? 'As senhas não coincidem.' : ' '}
                />
                <Button type="submit" variant="contained" fullWidth size="large" loading={loading}>
                    Alterar senha
                </Button>
            </Box>
        </AuthLayout>
    );
}

export default EsqueceuSenha;
